import * as React from 'react';

import {FormField, Block} from '../../LayoutComponents';
import {FormFieldProps} from '../../Definitions';

type PostalAddressProps = {
	name: string;
	getConfig: (key: string) => FormFieldProps;
}
export default ({name, getConfig}: PostalAddressProps) => (
	<Block>
		<FormField {...getConfig(`${name}.streetAddress`)}/>
		<Block half>
			<FormField {...getConfig(`${name}.postalCode`)}/>
		</Block>
		<Block half>
			<FormField {...getConfig(`${name}.addressLocality`)}/>
		</Block>
	</Block>
)
